import React from 'react';

export const GroudFloorPage = () => (
    <div>
      <h1>This is the GroundFloor Page</h1>
    </div>
  );